// extracted by mini-css-extract-plugin
module.exports = {"productPrelaunchNotice":"ProductPrelaunchNotice_productPrelaunchNotice__U8ye6"};